import(/* webpackMode: "eager" */ "/vercel/path0/modules/article/sanity/article-page-container/ArticlePageContainerDraft.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/image/ImageBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/vercel/path0/modules/foundation/components/video/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
